import React from "react";
import { RouterProvider, createBrowserRouter } from "react-router";
import { routes } from "./routes";

/**
 * Application router using React Router v7 Data Mode
 *
 * Benefits of this approach:
 * - Type-safe route definitions
 * - Automatic code splitting with lazy imports
 * - Built-in error boundaries
 * - Cleaner, more maintainable structure
 *
 * @see https://reactrouter.com/home
 */
const router = createBrowserRouter(routes, {
  future: {
    // Enable future flags for smoother v8 migration
    v7_relativeSplatPath: true,
    v7_fetcherPersist: true,
    v7_normalizeFormMethod: true,
    v7_partialHydration: true,
    v7_skipActionErrorRevalidation: true,
  },
});

export default function Router() {
  return <RouterProvider router={router} />;
}
